import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  fieldText: {
    width: pxToRem(320),
    fontSize: pxToRem(12),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
  tooltipContent: {
    margin: pxToRem(10),
    padding: pxToRem(15),
  },
  moreContents: {
    color: theme.palette.themePrimary,
  },
});
